export default {
    showCrosshair: false,
    solution: "bune"
};